import axios from '../axios-auth'

export const stockAnalysisService = {
    getCustomerStockAnalysisReport,
    getAllCustomerStockAnalysisReport,
    getStockAnalysisReport,
    getAllStockAnalysisReport,
}

function getCustomerStockAnalysisReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate="] = searchParams.toDate;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.customerShopIds) {
        params["customerShopIds"] = searchParams.customerShopIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }

    return axios.get("/auth/customer-stock-analysis-report", { params });
}

function getAllCustomerStockAnalysisReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.customerIds) {
        params["customerIds"] = searchParams.customerIds.join();
    }
    if (searchParams.customerShopIds) {
        params["customerShopIds"] = searchParams.customerShopIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }

    return axios.get("/auth/customer-stock-analysis-report-print", { params });
}

function getStockAnalysisReport(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    }
    else {
        page -= 1;
    }
    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/stock-analysis-report", { params });
}

function getAllStockAnalysisReport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.productIds) {
        params["productIds"] = searchParams.productIds.join();
    }
    if (searchParams.categoryIds) {
        params["categoryIds"] = searchParams.categoryIds.join();
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }

    return axios.get("/auth/stock-analysis-report-print", { params });
}